import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import HotRanking from "./components/HotRanking";
import LatestFeed from "./components/LatestFeed";
import TrendSection from "./components/TrendSection";
import TopicSection from "./components/TopicSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [query, setQuery] = useState("");

  return (
    <div id="top" className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} />
        <Ticker />
        <HotRanking query={query} />
        <LatestFeed />
        <TrendSection />
        <TopicSection />
        <AboutSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}